import Web3 from "web3";
import Torus from "@toruslabs/torus-embed";
import config from "../config.js";
import WalletConnectProvider from "@walletconnect/web3-provider";
//LIVE
const TRANS_ADDRS = [process.env.VUE_APP_TRANS_ADDRS_ETH, process.env.VUE_APP_TRANS_ADDRS_POL, process.env.VUE_APP_TRANS_ADDRS_AZ];
const LOKA_ADDRS = [process.env.VUE_APP_LOKA_ADDRS_ETH, process.env.VUE_APP_LOKA_ADDRS_POL, process.env.VUE_APP_LOKA_ADDRS_AZ];
const BREED_ADDR = "0xce97eaecab792a3d1f33b3bb4d6e2319658de485";
const HATCH_ADDR = "0x27da8c8887eb21c9a35becfbf23ad7621261c53d";
const DST_ADDR = "0x3b7e1ce09afe2bb3a23919afb65a38e627cfbe97";
const DRAGO_ADDR = "0xab226c1d6a4362423405816851748f1f866f5583";
const DRAGO_DEPOSIT_ADDR = "0xbe66e8983677ff32ec29a86ea814f044927a92b8";
const DRAGO_WITHDRAW_ADDR = "0xc53021e11bc0f5ce719d564b3e51eb1a06bdffaf";
const LOKA_ROOT_ADDR = "0x5f71d8de858fc038d0e19a5063940dc86a4e6268";
const LOKA_CHILD_ADDR = "0xfb47a80ba0c4c071ed295e7e004536ea9107012b";

//COMMON
const GOODS_ADDR = "0xc70C8440342ec506F61C3b0f56d3288A5B0d4BBb";
const MYSTERY_ADDR = "0x4bd0557bee69fd431fc843f313a34296885df154";
const TICKET_ADDR = "0xfc21a6cfd83149402f9ab138282e125025554d7f";
const MB_TICKET_ADDR = "0x2eae7894bf371eebe935b8712e3e6a2e54bbdb31";
const GENESIS_ADDR = "0xcc91454c9ed648f65a11c06af0dda626f1be7dfa";

export const LOKA_STAKING_ADDR = "0x196a26ef25beea61f9199e3f9d4c5c03377df786";
export const LOKA_STAKING_ABI =[
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_loka",
        "type": "address"
      },
      {
        "internalType": "contract Transmitter",
        "name": "_transmitter",
        "type": "address"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "level",
        "type": "uint256"
      }
    ],
    "name": "MembershipChanged",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "preOwner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "OwnerTransferred",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "uint256",
        "name": "continent",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "Stake",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "from",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "uint256",
        "name": "continent",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "Unstake",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      }
    ],
    "name": "getMembership",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "name": "indexes",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [],
    "name": "isAdmin",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [],
    "name": "isMinter",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [],
    "name": "isOwner",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "key",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "level",
        "type": "uint256"
      }
    ],
    "name": "setMembership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "name": "stakes",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "transferOwner",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "contract Transmitter",
        "name": "_transmitter",
        "type": "address"
      }
    ],
    "name": "setTransmitter",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address payable",
        "name": "_receiver",
        "type": "address"
      }
    ],
    "name": "setReceiver",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_loka",
        "type": "address"
      }
    ],
    "name": "setLoka",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "getReceiver",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [],
    "name": "getTransmitter",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [],
    "name": "getStakerCount",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [],
    "name": "getStakers",
    "outputs": [
      {
        "internalType": "address[]",
        "name": "",
        "type": "address[]"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "start",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "end",
        "type": "uint256"
      }
    ],
    "name": "getStakersRange",
    "outputs": [
      {
        "internalType": "address[]",
        "name": "",
        "type": "address[]"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [],
    "name": "getAmount",
    "outputs": [
      {
        "internalType": "uint256[]",
        "name": "",
        "type": "uint256[]"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "start",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "end",
        "type": "uint256"
      }
    ],
    "name": "getAmountRange",
    "outputs": [
      {
        "internalType": "uint256[]",
        "name": "",
        "type": "uint256[]"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "size",
        "type": "uint256"
      }
    ],
    "name": "getAmounts",
    "outputs": [
      {
        "internalType": "uint256[][]",
        "name": "",
        "type": "uint256[][]"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "size",
        "type": "uint256"
      },
      {
        "internalType": "address[]",
        "name": "owners",
        "type": "address[]"
      }
    ],
    "name": "getAmountsByAddress",
    "outputs": [
      {
        "internalType": "uint256[][]",
        "name": "",
        "type": "uint256[][]"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "size",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "start",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "end",
        "type": "uint256"
      }
    ],
    "name": "getAmountsRange",
    "outputs": [
      {
        "internalType": "uint256[][]",
        "name": "",
        "type": "uint256[][]"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "continent",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "stake",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "continent",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "unstake",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "continent",
        "type": "uint256"
      }
    ],
    "name": "stakeOf",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      }
    ],
    "name": "totalStakeOf",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "size",
        "type": "uint256"
      }
    ],
    "name": "allStakeOf",
    "outputs": [
      {
        "internalType": "uint256[]",
        "name": "",
        "type": "uint256[]"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "index",
        "type": "uint256"
      }
    ],
    "name": "stakeOfContinent",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [],
    "name": "totalStakeOfContinent",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "size",
        "type": "uint256"
      }
    ],
    "name": "allStakeOfContinent",
    "outputs": [
      {
        "internalType": "uint256[]",
        "name": "",
        "type": "uint256[]"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  }
];
export const ERC20_ABI = [{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approve","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"supply","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transferFrom","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"digits","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"}],"name":"balanceOf","outputs":[{"name":"balance","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transfer","outputs":[{"name":"success","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"},{"name":"_spender","type":"address"}],"name":"allowance","outputs":[{"name":"remaining","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"anonymous":false,"inputs":[{"indexed":true,"name":"_owner","type":"address"},{"indexed":true,"name":"_spender","type":"address"},{"indexed":false,"name":"_value","type":"uint256"}],"name":"Approval","type":"event"}];
//export var contract;
export var web3 = new Web3();

var networkCheckTimer = null;

export const ETH = (value) => {
  if(value==null)
    return 0;
  return Number(web3.utils.fromWei(value.toString(), "ether"));
}
export const ETHS = (values) => {
  let list = [];
  for(let i=0; i<values.length; ++i)
    list.push(ETH(values[i]));
  return list;
}

export const WEI = (value) => {
    value = value.toString().substr(0, 16)
    return web3.utils.toWei(value, "ether");
}
export const connectWallet = async (store, wallet) => {
    let account = null;
    if (wallet == null) {
        wallet = localStorage.getItem('wallet');
    }

    if (wallet == "metamask") {
        let provider = window.ethereum;
        web3 = new Web3(provider);
        const accounts = await provider.enable();
        console.log(accounts);
        account = { address: accounts[0], balance: 0 };
    } else if (wallet == "coin98") {
        let provider = window.coin98.provider;
        web3 = new Web3(provider);
        const accounts = await provider.enable();
        console.log(accounts);
        account = { address: accounts[0], balance: 0 };
    } else if (wallet == "walletconnect") {
        const provider = new WalletConnectProvider({
            infuraId: "a42a4adc5de147648e804d9fa47a1c3a", // Required
        });
        await provider.enable();
        web3 = new Web3(provider);
        account = {
            address: web3.eth.accounts.currentProvider.accounts[0],
            balance: 0
        };
    } else if (wallet == "dappcom") {
        console.log("DAPPCONNECTED");
        await window.loadScript("lib/DappStoreWallet-Ethereum");
        await window.loadScript("lib/web3.min");
        window.dappstore = new window.DappStoreWallet(
            "d03db299-0231-49bf-95d6-5b4c6f898167"
        );
        web3 = new Web3(window.dappstore.provider);
        console.log("DAPPCONNECTED");
        account = {
            address: web3.eth.accounts.currentProvider.selectedAddress,
            balance: 0
        };
    } else if (wallet == "torus") {
        const torus = new Torus();
        await torus.init({
            network: {
                host: config.eth.networks[config.eth.net]
            }
        });
        await torus.ethereum.enable();
        web3 = new Web3(torus.provider);
        console.log(web3.eth.accounts.currentProvider.selectedAddress);
        account = {
            address: web3.eth.accounts.currentProvider.selectedAddress,
            balance: 0
        };
    }
    if (account != null) {
        // contract = new web3.eth.Contract(
        //     KingdomLandSale.abi,
        //     KingdomLandSale.networks[config.eth.net].address
        // );
        account.address = account.address.toLowerCase();
        localStorage.setItem('wallet', wallet);
        store.commit('setAccount', { wallet: wallet, account: account });

        // var ret = await axios.post(
        //     `${config.api.nft_url}/landlord/info`,
        //     {
        //         address: account.address
        //     }
        //   );
        // if (ret.data.result) {
        //     store.commit('setLandLord', { landLordInfo: ret.data.landLordInfo });
        // }

        await refreshAccountBalance(store);

        let networkId = await getNetwork();
        store.state.account.networkId = networkId;

        // if (networkCheckTimer == null) {
        //   networkCheckTimer = setInterval(async () => {
            
        //   }, 000);
        // }        
    }
    else {
        if (networkCheckTimer != null) {
          clearInterval(networkCheckTimer);
          networkCheckTimer = null;
        }
        store.state.account.networkId = 0;
        localStorage.removeItem('wallet');
        store.commit('clearAccount');
    }
    return account;
}

export const disconnectWallet = (store) => {
    if (networkCheckTimer != null) {
      clearInterval(networkCheckTimer);
      networkCheckTimer = null;
    }
    store.state.account.networkId = 0;
    localStorage.removeItem('wallet');
    store.commit('clearAccount');
}

export const refreshAccountBalance = async (store) => {
    let account = store.state.account.wallet;
    let token = store.state.account.token;
    if (account == null) {
        return;
    }
    if (token.token_symbol == 'ETH') {
        let balance = await web3.eth.getBalance(account.address);
        store.commit('setBalance', ETH(balance));
    }
    else {
        const SRC_TOKEN_CONTRACT = new web3.eth.Contract(ERC20_ABI, token.token_address);
        store.commit('setBalance', ETH(await SRC_TOKEN_CONTRACT.methods.balanceOf(account.address).call()));
    }
}
export const getNetwork = async (store) => {
  return await web3.eth.net.getId();
}
export const sign = async (store, data) =>{
  let account = store.state.account.wallet;
  return await web3.eth.personal.sign(web3.utils.fromUtf8(data), account.address);
}
export const changeNetwork = async (networkId) => {
  await web3.currentProvider.request({
    method: "wallet_switchEthereumChain",
    params: [{ chainId: web3.utils.toHex(Number(networkId)), }],
  })
  return await web3.eth.net.getId();
}
export const refreshStickers = async (store) => {
  console.log(store);
  let account = store.state.account.wallet;
  if (account == null) {
      return;
  }
  let ctr = new web3.eth.Contract([
      {
        "inputs": [
          {
            "internalType": "string",
            "name": "name",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "symbol",
            "type": "string"
          }
        ],
        "stateMutability": "nonpayable",
        "type": "constructor"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "address",
            "name": "owner",
            "type": "address"
          },
          {
            "indexed": true,
            "internalType": "address",
            "name": "approved",
            "type": "address"
          },
          {
            "indexed": true,
            "internalType": "uint256",
            "name": "tokenId",
            "type": "uint256"
          }
        ],
        "name": "Approval",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "address",
            "name": "owner",
            "type": "address"
          },
          {
            "indexed": true,
            "internalType": "address",
            "name": "operator",
            "type": "address"
          },
          {
            "indexed": false,
            "internalType": "bool",
            "name": "approved",
            "type": "bool"
          }
        ],
        "name": "ApprovalForAll",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "address",
            "name": "owner",
            "type": "address"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "level",
            "type": "uint256"
          }
        ],
        "name": "MembershipChanged",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "address",
            "name": "to",
            "type": "address"
          },
          {
            "indexed": true,
            "internalType": "uint256",
            "name": "id",
            "type": "uint256"
          }
        ],
        "name": "Mint",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "address",
            "name": "preOwner",
            "type": "address"
          },
          {
            "indexed": true,
            "internalType": "address",
            "name": "newOwner",
            "type": "address"
          }
        ],
        "name": "OwnerTransferred",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "address",
            "name": "from",
            "type": "address"
          },
          {
            "indexed": true,
            "internalType": "address",
            "name": "to",
            "type": "address"
          },
          {
            "indexed": true,
            "internalType": "uint256",
            "name": "tokenId",
            "type": "uint256"
          }
        ],
        "name": "Transfer",
        "type": "event"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "to",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "tokenId",
            "type": "uint256"
          }
        ],
        "name": "approve",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "owner",
            "type": "address"
          }
        ],
        "name": "balanceOf",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function",
        "constant": true
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "tokenId",
            "type": "uint256"
          }
        ],
        "name": "getApproved",
        "outputs": [
          {
            "internalType": "address",
            "name": "",
            "type": "address"
          }
        ],
        "stateMutability": "view",
        "type": "function",
        "constant": true
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "account",
            "type": "address"
          }
        ],
        "name": "getMembership",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function",
        "constant": true
      },
      {
        "inputs": [],
        "name": "isAdmin",
        "outputs": [
          {
            "internalType": "bool",
            "name": "",
            "type": "bool"
          }
        ],
        "stateMutability": "view",
        "type": "function",
        "constant": true
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "owner",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "operator",
            "type": "address"
          }
        ],
        "name": "isApprovedForAll",
        "outputs": [
          {
            "internalType": "bool",
            "name": "",
            "type": "bool"
          }
        ],
        "stateMutability": "view",
        "type": "function",
        "constant": true
      },
      {
        "inputs": [],
        "name": "isMinter",
        "outputs": [
          {
            "internalType": "bool",
            "name": "",
            "type": "bool"
          }
        ],
        "stateMutability": "view",
        "type": "function",
        "constant": true
      },
      {
        "inputs": [],
        "name": "isOwner",
        "outputs": [
          {
            "internalType": "bool",
            "name": "",
            "type": "bool"
          }
        ],
        "stateMutability": "view",
        "type": "function",
        "constant": true
      },
      {
        "inputs": [],
        "name": "name",
        "outputs": [
          {
            "internalType": "string",
            "name": "",
            "type": "string"
          }
        ],
        "stateMutability": "view",
        "type": "function",
        "constant": true
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "tokenId",
            "type": "uint256"
          }
        ],
        "name": "ownerOf",
        "outputs": [
          {
            "internalType": "address",
            "name": "",
            "type": "address"
          }
        ],
        "stateMutability": "view",
        "type": "function",
        "constant": true
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "from",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "to",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "tokenId",
            "type": "uint256"
          }
        ],
        "name": "safeTransferFrom",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "from",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "to",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "tokenId",
            "type": "uint256"
          },
          {
            "internalType": "bytes",
            "name": "_data",
            "type": "bytes"
          }
        ],
        "name": "safeTransferFrom",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "operator",
            "type": "address"
          },
          {
            "internalType": "bool",
            "name": "approved",
            "type": "bool"
          }
        ],
        "name": "setApprovalForAll",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "key",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "level",
            "type": "uint256"
          }
        ],
        "name": "setMembership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "bytes4",
            "name": "interfaceId",
            "type": "bytes4"
          }
        ],
        "name": "supportsInterface",
        "outputs": [
          {
            "internalType": "bool",
            "name": "",
            "type": "bool"
          }
        ],
        "stateMutability": "view",
        "type": "function",
        "constant": true
      },
      {
        "inputs": [],
        "name": "symbol",
        "outputs": [
          {
            "internalType": "string",
            "name": "",
            "type": "string"
          }
        ],
        "stateMutability": "view",
        "type": "function",
        "constant": true
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "index",
            "type": "uint256"
          }
        ],
        "name": "tokenByIndex",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function",
        "constant": true
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "owner",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "index",
            "type": "uint256"
          }
        ],
        "name": "tokenOfOwnerByIndex",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function",
        "constant": true
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "tokenId",
            "type": "uint256"
          }
        ],
        "name": "tokenURI",
        "outputs": [
          {
            "internalType": "string",
            "name": "",
            "type": "string"
          }
        ],
        "stateMutability": "view",
        "type": "function",
        "constant": true
      },
      {
        "inputs": [],
        "name": "totalSupply",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function",
        "constant": true
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "from",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "to",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "tokenId",
            "type": "uint256"
          }
        ],
        "name": "transferFrom",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "newOwner",
            "type": "address"
          }
        ],
        "name": "transferOwner",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "string",
            "name": "uri",
            "type": "string"
          }
        ],
        "name": "setBaseURI",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "to",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "tokenId",
            "type": "uint256"
          }
        ],
        "name": "mint",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address[]",
            "name": "tos",
            "type": "address[]"
          },
          {
            "internalType": "uint256[]",
            "name": "tokenIds",
            "type": "uint256[]"
          }
        ],
        "name": "mints",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "to",
            "type": "address"
          },
          {
            "internalType": "uint256[]",
            "name": "tokenIds",
            "type": "uint256[]"
          }
        ],
        "name": "mintsTo",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "tokenId",
            "type": "uint256"
          }
        ],
        "name": "burn",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "uint256[]",
            "name": "tokenIds",
            "type": "uint256[]"
          }
        ],
        "name": "burns",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "allTokens",
        "outputs": [
          {
            "internalType": "uint256[]",
            "name": "",
            "type": "uint256[]"
          }
        ],
        "stateMutability": "view",
        "type": "function",
        "constant": true
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "owner",
            "type": "address"
          }
        ],
        "name": "ownedTokens",
        "outputs": [
          {
            "internalType": "uint256[]",
            "name": "",
            "type": "uint256[]"
          }
        ],
        "stateMutability": "view",
        "type": "function",
        "constant": true
      }
    ], "0xc70c8440342ec506f61c3b0f56d3288a5b0d4bbb");
    let result = await ctr.methods.ownedTokens(account.address).call();
    store.commit('setStickers', result);
}

export const craftGoods = async (store, tokenIds) => {
    let account = store.state.account.wallet;
    if (account == null) {
        return;
    }
    let ctr = new web3.eth.Contract([
      {
        "inputs": [
          {
            "internalType": "contract LOKGoods",
            "name": "_good",
            "type": "address"
          }
        ],
        "stateMutability": "nonpayable",
        "type": "constructor"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "address",
            "name": "owner",
            "type": "address"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "level",
            "type": "uint256"
          }
        ],
        "name": "MembershipChanged",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": false,
            "internalType": "uint256[]",
            "name": "tokenIds",
            "type": "uint256[]"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "id",
            "type": "uint256"
          }
        ],
        "name": "Merge",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "address",
            "name": "preOwner",
            "type": "address"
          },
          {
            "indexed": true,
            "internalType": "address",
            "name": "newOwner",
            "type": "address"
          }
        ],
        "name": "OwnerTransferred",
        "type": "event"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "account",
            "type": "address"
          }
        ],
        "name": "getMembership",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function",
        "constant": true
      },
      {
        "inputs": [],
        "name": "isAdmin",
        "outputs": [
          {
            "internalType": "bool",
            "name": "",
            "type": "bool"
          }
        ],
        "stateMutability": "view",
        "type": "function",
        "constant": true
      },
      {
        "inputs": [],
        "name": "isMinter",
        "outputs": [
          {
            "internalType": "bool",
            "name": "",
            "type": "bool"
          }
        ],
        "stateMutability": "view",
        "type": "function",
        "constant": true
      },
      {
        "inputs": [],
        "name": "isOwner",
        "outputs": [
          {
            "internalType": "bool",
            "name": "",
            "type": "bool"
          }
        ],
        "stateMutability": "view",
        "type": "function",
        "constant": true
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "key",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "level",
            "type": "uint256"
          }
        ],
        "name": "setMembership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "newOwner",
            "type": "address"
          }
        ],
        "name": "transferOwner",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "receiver",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "postfix",
            "type": "uint256"
          }
        ],
        "name": "send",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "uint256[]",
            "name": "tokenIds",
            "type": "uint256[]"
          }
        ],
        "name": "merge",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      }
    ], "0xd370dcb28adb6cac58fe939040e7efc8929e75f6");

      const param = {
        to: "0xd370dcb28adb6cac58fe939040e7efc8929e75f6",
        from: account.address,
        data: ctr.methods.merge(tokenIds).encodeABI(),
      }
      try {
        var result = await web3.eth.sendTransaction(param);
        return result;
      }
      catch (e) {
        console.log(e);
        return {};

      }
      console.log(result);
      store.commit('setStickers', result);
}
const GOODS_ABI = [
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      }
    ],
    "name": "balanceOf",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  }
];
const TICKET_ABI = [
  {
    "inputs": [],
    "name": "burns",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },{
    "inputs": [
      {
        "internalType": "address",
        "name": "owner",
        "type": "address"
      }
    ],
    "name": "balanceOf",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  }
];
const GENESIS_ABI = [
  {
    "inputs": [
      {
        "internalType": "contract IERC20",
        "name": "_loka",
        "type": "address"
      },
      {
        "internalType": "contract Drago",
        "name": "_drago",
        "type": "address"
      },
      {
        "internalType": "contract DragoEgg",
        "name": "_egg",
        "type": "address"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "have",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "want",
        "type": "address"
      }
    ],
    "name": "OnlyCoordinatorCanFulfill",
    "type": "error"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "owner",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "level",
        "type": "uint256"
      }
    ],
    "name": "MembershipChanged",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "preOwner",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "OwnerTransferred",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "account",
        "type": "address"
      }
    ],
    "name": "getMembership",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [],
    "name": "isAdmin",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [],
    "name": "isMinter",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [],
    "name": "isOwner",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "requestId",
        "type": "uint256"
      },
      {
        "internalType": "uint256[]",
        "name": "randomWords",
        "type": "uint256[]"
      }
    ],
    "name": "rawFulfillRandomWords",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "key",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "level",
        "type": "uint256"
      }
    ],
    "name": "setMembership",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "subscriptionId",
    "outputs": [
      {
        "internalType": "uint64",
        "name": "",
        "type": "uint64"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "newOwner",
        "type": "address"
      }
    ],
    "name": "transferOwner",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "contract IERC20",
        "name": "addr",
        "type": "address"
      }
    ],
    "name": "setLoka",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "start",
        "type": "uint256"
      }
    ],
    "name": "setStart",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "min",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "max",
        "type": "uint256"
      }
    ],
    "name": "setDuration",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "min",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "max",
        "type": "uint256"
      }
    ],
    "name": "setGuildRound",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "min",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "max",
        "type": "uint256"
      }
    ],
    "name": "setPrivateRound",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "r",
        "type": "address"
      }
    ],
    "name": "setTokenReceiver",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256[]",
        "name": "rs",
        "type": "uint256[]"
      }
    ],
    "name": "setRemains",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256[]",
        "name": "rs",
        "type": "uint256[]"
      }
    ],
    "name": "setRehatches",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address[]",
        "name": "addrs",
        "type": "address[]"
      },
      {
        "internalType": "uint256[]",
        "name": "values",
        "type": "uint256[]"
      }
    ],
    "name": "setWhitelist",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address[]",
        "name": "addrs",
        "type": "address[]"
      }
    ],
    "name": "setFixedWhitelist",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address[]",
        "name": "addrs",
        "type": "address[]"
      },
      {
        "internalType": "uint256[]",
        "name": "values",
        "type": "uint256[]"
      }
    ],
    "name": "setGuildlist",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "inDuration",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [],
    "name": "inGuildRound",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [],
    "name": "inPrivateRound",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [],
    "name": "getTimestamp",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "addr",
        "type": "address"
      }
    ],
    "name": "getWhitelist",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "count",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "addr",
        "type": "address"
      }
    ],
    "name": "getGuildlist",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "count",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "consumerAddress",
        "type": "address"
      }
    ],
    "name": "addConsumer",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "consumerAddress",
        "type": "address"
      }
    ],
    "name": "removeConsumer",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      }
    ],
    "name": "topUpSubscription",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "receivingWallet",
        "type": "address"
      }
    ],
    "name": "cancelSubscription",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      },
      {
        "internalType": "address",
        "name": "to",
        "type": "address"
      }
    ],
    "name": "withdraw",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256[]",
        "name": "types1",
        "type": "uint256[]"
      },
      {
        "internalType": "uint256[]",
        "name": "types2",
        "type": "uint256[]"
      }
    ],
    "name": "batchBreeding",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "type1",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "type2",
        "type": "uint256"
      }
    ],
    "name": "breeding",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "type1",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "type2",
        "type": "uint256"
      }
    ],
    "name": "getPrice",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "pure",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "hatching",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "canRehatch",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "setRehatch",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "rehatching",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "sender",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "parents",
        "type": "uint256"
      }
    ],
    "name": "toReqData",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "pure",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "requestId",
        "type": "uint256"
      }
    ],
    "name": "getRequests",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [
      {
        "internalType": "uint256[]",
        "name": "randomWords",
        "type": "uint256[]"
      },
      {
        "internalType": "uint256",
        "name": "max",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "min",
        "type": "uint256"
      }
    ],
    "name": "rand",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "pure",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [],
    "name": "getRemains",
    "outputs": [
      {
        "internalType": "uint256[]",
        "name": "",
        "type": "uint256[]"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [],
    "name": "getRehatches",
    "outputs": [
      {
        "internalType": "uint256[]",
        "name": "",
        "type": "uint256[]"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [],
    "name": "getNext",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function",
    "constant": true
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "n",
        "type": "uint256"
      }
    ],
    "name": "setNext",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256[]",
        "name": "randomWords",
        "type": "uint256[]"
      },
      {
        "internalType": "uint256",
        "name": "param",
        "type": "uint256"
      }
    ],
    "name": "computeTests",
    "outputs": [
      {
        "internalType": "uint256[]",
        "name": "",
        "type": "uint256[]"
      }
    ],
    "stateMutability": "pure",
    "type": "function",
    "constant": true
  }
];
const BREED_ABI = [
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "parent1",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "parent2",
        "type": "uint256"
      }
    ],
    "name": "breeding",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  }
];

const HATCH_ABI = [
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "tokenId",
        "type": "uint256"
      }
    ],
    "name": "hatching",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  }
];
const DRAGO_DEPOSIT_ABI = [{
  "inputs": [
    {
      "internalType": "address",
      "name": "rootToken",
      "type": "address"
    },
    {
      "internalType": "uint256[]",
      "name": "tokenIds",
      "type": "uint256[]"
    }
  ],
  "name": "deposits",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
}];
const DRAGO_WITHDRAW_ABI = [];
const LOKA_ROOT_ABI = [{
  "inputs": [
    {
      "internalType": "address",
      "name": "rootToken",
      "type": "address"
    },
    {
      "internalType": "uint256",
      "name": "amount",
      "type": "uint256"
    }
  ],
  "name": "deposit",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
},{
  "inputs": [
    {
      "internalType": "bytes",
      "name": "inputData",
      "type": "bytes"
    }
  ],
  "name": "receiveMessage",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
}];
const LOKA_CHILD_ABI = [{
  "inputs": [
    {
      "internalType": "address",
      "name": "childToken",
      "type": "address"
    },
    {
      "internalType": "uint256",
      "name": "amount",
      "type": "uint256"
    }
  ],
  "name": "withdraw",
  "outputs": [],
  "stateMutability": "nonpayable",
  "type": "function"
}];

export const stakeOf = async (store, continent)=>{
  let account = store.state.account.wallet;
  if (account == null) {
      return;
  }
  let ctr = new web3.eth.Contract(LOKA_STAKING_ABI, LOKA_STAKING_ADDR);
  return ETH(await ctr.methods.stakeOf(account.address, continent).call());
}
export const allStakeOf = async (store, continent)=>{
  let account = store.state.account.wallet;
  if (account == null) {
      return;
  }
  let ctr = new web3.eth.Contract(LOKA_STAKING_ABI, LOKA_STAKING_ADDR);
  return ETHS(await ctr.methods.allStakeOf(account.address, continent).call());
}
export const lokaBalance = async (store, network=0) => {
  let account = store.state.account.wallet;
  if (account == null) {
      return;
  }
  let ctr = new web3.eth.Contract(ERC20_ABI, LOKA_ADDRS[network]);
  return ETH(await ctr.methods.balanceOf(account.address).call());
}
export const getNumDragoSticker = async (store) => {
  let account = store.state.account.wallet;
  if (account == null) {
      return;
  }
  let ctr = new web3.eth.Contract(GOODS_ABI, GOODS_ADDR);
  return await ctr.methods.balanceOf(account.address).call();
}
export const getNumDragoMysteryBox = async (store) => {
  let account = store.state.account.wallet;
  if (account == null) {
      return;
  }
  let ctr = new web3.eth.Contract(GOODS_ABI, MB_TICKET_ADDR);
  return await ctr.methods.balanceOf(account.address).call();
}
export const stakeLoka = (store, continent, amount)=>{
  let account = store.state.account.wallet;
  if (account == null) {
      return;
  }
  let ctr = new web3.eth.Contract(LOKA_STAKING_ABI, LOKA_STAKING_ADDR);
    const param = {
      to: LOKA_STAKING_ADDR,
      from: account.address,
      data: ctr.methods.stake(continent, WEI(amount)).encodeABI(),
    }
    return web3.eth.sendTransaction(param);
}
export const unstakeLoka = (store, continent, amount)=>{
  let account = store.state.account.wallet;
  if (account == null) {
      return;
  }
  let ctr = new web3.eth.Contract(LOKA_STAKING_ABI, LOKA_STAKING_ADDR);
    const param = {
      to: LOKA_STAKING_ADDR,
      from: account.address,
      data: ctr.methods.unstake(continent, WEI(amount)).encodeABI(),
    }
    return web3.eth.sendTransaction(param);
}
export const burnsSticker = (store) =>{
  let account = store.state.account.wallet;
  if (account == null) {
      return;
  }
    let ctr = new web3.eth.Contract(TICKET_ABI, TICKET_ADDR);
    const param = {
      to: TICKET_ADDR,
      from: account.address,
      data: ctr.methods.burns().encodeABI(),
    }
    return web3.eth.sendTransaction(param);
}
export const burnsDragoMysteryBox = (store) =>{
  let account = store.state.account.wallet;
  if (account == null) {
      return;
  }
    let ctr = new web3.eth.Contract(TICKET_ABI, MB_TICKET_ADDR);
    const param = {
      to: MB_TICKET_ADDR,
      from: account.address,
      data: ctr.methods.burns().encodeABI(),
    }
    console.log(param);
    return web3.eth.sendTransaction(param);
}
async function lokaAllowance(store, network=0)  {
  let account = store.state.account.wallet;
  if (account == null) {
      return;
  }
  let ctr = new web3.eth.Contract(ERC20_ABI, LOKA_ADDRS[network]);
  return await ctr.methods.allowance(account.address, TRANS_ADDRS[network]).call();
}
async function lokaApprove(store, network=0)  {
  return new Promise(async (resolve, reject) => {
    try {
	  let account = store.state.account.wallet;
	  if (account == null) {
	      return;
	  }
      let ctr = new web3.eth.Contract(ERC20_ABI, LOKA_ADDRS[network]);
      const param = {
        to: LOKA_ADDRS[network],
        from: account.address,
        data: ctr.methods.approve(TRANS_ADDRS[network], WEI(1000000000000)).encodeABI(),
      }

      store.commit('openModal', 'approval');

      web3.eth.sendTransaction(param).on('receipt', async (receipt) => {
        store.commit('closeModal', 'approval');
        resolve({result: true, data: receipt});
      }).on('error', (error) => {
        console.log("error")
        console.log(error);
        reject(error);
      });
    }
    catch (err) {
        reject(err);
    }
});
}
export const checkLoka = async (store, network=0, amount=0) =>{
  
  let account = store.state.account.wallet;
  if (account == null) {
      return;
  }

  let allowance = await lokaAllowance(store, network);
  let value = allowance.length>18?parseInt(allowance.substr(0, allowance.length-18)):0;
  console.log(allowance, allowance.length, value, amount, allowance.length<18, value<amount, allowance.length<18||value<amount)
  if(allowance.length<18||value<amount)
    await lokaApprove(store, network);
}

async function dstAllowance(store, network=0)  {
  let account = store.state.account.wallet;
  if (account == null) {
      return;
  }
  let ctr = new web3.eth.Contract(ERC20_ABI, DST_ADDR);
  return await ctr.methods.allowance(account.address, TRANS_ADDRS[network]).call();
}
async function dstApprove(store, network=0)  {
  return new Promise(async (resolve, reject) => {
    try {
	  let account = store.state.account.wallet;
	  if (account == null) {
	      return;
	  }
      let ctr = new web3.eth.Contract(ERC20_ABI, DST_ADDR);
      const param = {
        to: DST_ADDR,
        from: account.address,
        data: ctr.methods.approve(TRANS_ADDRS[network], WEI(1000000000000)).encodeABI(),
      }

      store.commit('openModal', 'approvalDST');

      web3.eth.sendTransaction(param).on('receipt', async (receipt) => {
        store.commit('closeModal', 'approvalDST');
        resolve({result: true, data: receipt});
      }).on('error', (error) => {
        console.log("error")
        console.log(error);
        reject(error);
      });
    }
    catch (err) {
        reject(err);
    }
});
}
export const checkDst = async (store, network=0, amount=0) =>{
  
  let account = store.state.account.wallet;
  if (account == null) {
      return;
  }

  let allowance = await dstAllowance(store, network);
  let value = allowance.length>18?parseInt(allowance.substr(0, allowance.length-18)):0;
  console.log(allowance, allowance.length, value, amount, allowance.length<18, value<amount, allowance.length<18||value<amount)
  if(allowance.length<18||value<amount)
    await dstApprove(store, network);
}

export const depositLoka = (store, amount) => {
  let account = store.state.account.wallet;
  if (account == null) {
      return;
  }
  let ctr = new web3.eth.Contract(LOKA_ROOT_ABI, LOKA_ROOT_ADDR);
    const param = {
      to: LOKA_ROOT_ADDR,
      from: account.address,
      data: ctr.methods.deposit(LOKA_ADDRS[0], WEI(amount)).encodeABI(),
    }
    return web3.eth.sendTransaction(param);
}
export const withdrawLoka = (store, amount) => {
  let account = store.state.account.wallet;
  if (account == null) {
      return;
  }
  let ctr = new web3.eth.Contract(LOKA_CHILD_ABI, LOKA_CHILD_ADDR);
    const param = {
      to: LOKA_CHILD_ADDR,
      from: account.address,
      data: ctr.methods.withdraw(LOKA_ADDRS[1], WEI(amount)).encodeABI(),
    }
    return web3.eth.sendTransaction(param);
}
export const withdrawReceive = (store, sig) => {
  let account = store.state.account.wallet;
  if (account == null) {
      return;
  }
  let ctr = new web3.eth.Contract(LOKA_ROOT_ABI, LOKA_ROOT_ADDR);
    const param = {
      to: LOKA_ROOT_ADDR,
      from: account.address,
      data: ctr.methods.receiveMessage(sig).encodeABI(),
    }
    return web3.eth.sendTransaction(param);
}
// async function lokaAllowance(store)  {
//   let account = store.state.account.wallet;
//   if (account == null) {
//       return;
//   }
//   let ctr = new web3.eth.Contract(ERC20_ABI, LOKA_ADDR);
//   return await ctr.methods.allowance(account.address, GENESIS_ADDR).call();
// }
// async function lokaApprove(store)  {
//   return new Promise(async (resolve, reject) => {
//     try {
// 	  let account = store.state.account.wallet;
// 	  if (account == null) {
// 	      return;
// 	  }
//       let ctr = new web3.eth.Contract(ERC20_ABI, LOKA_ADDR);
//       const param = {
//         to: LOKA_ADDR,
//         from: account.address,
//         data: ctr.methods.approve(GENESIS_ADDR, WEI(1000000000000)).encodeABI(),
//       }

//       store.commit('openModal', 'approval');

//       web3.eth.sendTransaction(param).on('receipt', async (receipt) => {
//         store.commit('closeModal', 'approval');
//         resolve({result: true, data: receipt});
//       }).on('error', (error) => {
//         console.log("error")
//         console.log(error);
//         reject(error);
//       });
//     }
//     catch (err) {
//         reject(err);
//     }
// });
// }


// export const checkLoka = async (store) =>{
  
//   let account = store.state.account.wallet;
//   if (account == null) {
//       return;
//   }

//   let allowance = await lokaAllowance(store);
//   console.log(allowance, allowance=="0")
//   if(allowance=="0")
//     await lokaApprove(store);
// }

export const depositDrago = (store, list) => {
  let account = store.state.account.wallet;
  if (account == null) {
      return;
  }
  let ctr = new web3.eth.Contract(DRAGO_DEPOSIT_ABI, DRAGO_DEPOSIT_ADDR);
    const param = {
      to: DRAGO_DEPOSIT_ADDR,
      from: account.address,
      data: ctr.methods.deposits(DRAGO_ADDR, list).encodeABI(),
    }
    return web3.eth.sendTransaction(param);
}


export const breedDrago = (store, ids) => {
    let account = store.state.account.wallet;
    if (account == null) {
        return;
    }
    let ctr = new web3.eth.Contract(BREED_ABI, BREED_ADDR);
    console.log(ids[0], ids[1])
      const param = {
        to: BREED_ADDR,
        from: account.address,
        data: ctr.methods.breeding(ids[0],ids[1]).encodeABI(),
      }
      return web3.eth.sendTransaction(param);
  }

export const batchBreedDrago = (store, list) => {
  let account = store.state.account.wallet;
  if (account == null) {
      return;
  }
  let ctr = new web3.eth.Contract(GENESIS_ABI, GENESIS_ADDR);
    const param = {
      to: GENESIS_ADDR,
      from: account.address,
      data: ctr.methods.batchBreeding(list[0], list[1]).encodeABI(),
    }
    return web3.eth.sendTransaction(param);
}
export const sendTransaction = (param) =>{
  return web3.eth.sendTransaction(param);
}

export const hatchDrago = (store, tokenId, network=1) => {
  let account = store.state.account.wallet;
  if (account == null) {
      return;
  }
  if(network==0){
    let ctr = new web3.eth.Contract(GENESIS_ABI, GENESIS_ADDR);
    const param = {
      to: GENESIS_ADDR,
      from: account.address,
      data: ctr.methods.hatching(tokenId).encodeABI(),
    }
    return web3.eth.sendTransaction(param);
  }
  else{//network==1
    let ctr = new web3.eth.Contract(HATCH_ABI, HATCH_ADDR);
    const param = {
      to: HATCH_ADDR,
      from: account.address,
      data: ctr.methods.hatching(tokenId).encodeABI(),
    }
    return web3.eth.sendTransaction(param);
  }
}

export const packUint256Array = (array) =>{
  let list = [array.length, ...array]
  return list.map(item => BigInt(item).toString(16).padStart(64, '0')).join('');
}
export const packUint256 = (value) =>{
  return BigInt(value).toString(16).padStart(64, '0')
}
export const send = (from, contract, data) =>{
  const param = {
    to: contract,
    from: from,
    data: data,
  }
  console.log(param);
  return web3.eth.sendTransaction(param);
}
export const rehatchDrago = (store, tokenId) => {
  let account = store.state.account.wallet;
  if (account == null) {
      return;
  }
  let ctr = new web3.eth.Contract(GENESIS_ABI, GENESIS_ADDR);
    const param = {
      to: GENESIS_ADDR,
      from: account.address,
      data: ctr.methods.rehatching(tokenId).encodeABI(),
    }
    return web3.eth.sendTransaction(param);
}